module.exports = __webpack_public_path__ + "static/img/hotjar.4507f74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/hotjar.png
// module id = VX2y
// module chunks = 0 139